<template>

  <el-dialog
      v-model="intVisible"
      :title="title"
      class="modal-95-70-60"
      :before-close="() => $emit('close')"
  >
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="() => $emit('close')">Отмена</el-button>
        <el-button type="success" :loading="isSaving" @click="addEditTemplate" :disabled="!canSave">{{
            confirmButtonText
          }}</el-button>
      </span>
    </template>

    <el-form
        :model="templateData"
        label-position="top"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="Название шаблона" class="bold-label">
            <el-input v-model="templateData.title" :disabled="!!editingTemplateId"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="Текст шаблона" class="bold-label">
            <el-input type="textarea" v-model="templateData.text" :rows="10"/>
          </el-form-item>

          <h4>Кнопки</h4>
          <el-row :gutter="20" v-for="(btn, i) in templateData.buttons" :key="'btn_vk' + i">
            <el-col :span="12">
              <el-form-item label="Текст" class="bold-label">
                <el-input v-model="btn.label"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="Ссылка" class="bold-label">
                <el-input v-model="btn.link"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item label=" " class="bold-label">
                <el-button  size="small" @click="deleteButton(i)"><font-awesome-icon icon="trash"/></el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-button type="success" size="small" @click="addEmptyButton">Добавить</el-button>
        </el-col>
      </el-row>
      <el-divider />
      <el-row :gutter="40">
        <el-col :md="12" :xs="24">
          <el-form-item label="Email для уведомлений" class="bold-label">
            <el-input v-model="templateData.notifyEmail"></el-input>
          </el-form-item>
          <el-form-item label="Наименование сервиса" class="bold-label">
            <el-select filterable v-model="templateData.vkService" class="full-width">
              <el-option
                  v-for="opt in allowedServices || []"
                  :label="opt"
                  :value="opt"
              />
            </el-select>
            <!--            <el-input v-model="templateData.vkService"></el-input>-->
          </el-form-item>
        </el-col>
        <el-col :md="12" :xs="24">
          <el-form-item label="URL группы Вконтакте" class="bold-label">
            <el-input v-model="templateData.vkGroupUrl"></el-input>
          </el-form-item>
          <el-form-item label="URL группы в Одноклассниках" class="bold-label">
            <el-input v-model="templateData.okGroupUrl"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
  </el-dialog>

</template>


<script>


export default {
  name: 'VkTemplateForm',
  props: ["visible", "editingTemplateId", "allowedServices"],
  emits: ["templateSaved", 'close'],
  watch: {
    visible(v) {
      this.intVisible = v
      if (v && !this.editingTemplateId) {
        if (this.allowedServices && this.allowedServices.length === 1)
          this.templateData.vkService = this.allowedServices[0]
      }
    },
    editingTemplateId(newVal) {
      if (newVal === "") this.clear()
    }
  },
  computed: {
    isEditing() {
      return !!this.editingTemplateId
    },
    title() {
      return this.isEditing ? "ИЗМЕНИТЬ ШАБЛОН" : "СОЗДАТЬ ШАБЛОН"
    },
    confirmButtonText() {
      return this.isEditing ? "Изменить" : "Добавить"
    },
    canSave() {
      return this.templateData.title.length > 0 && this.templateData.text.length > 0 && this.templateData.vkService.length > 0 && this.templateData.notifyEmail.length > 0 && this.templateData.vkGroupUrl.length > 0
    }
  },
  methods: {
    clear() {
      // this.selectedService = ""
      this.templateData.title = ""
      this.templateData.text = ""
      this.templateData.oldName = ""
      this.templateData.notifyEmail = ""
      this.templateData.vkService = ""
      this.templateData.vkGroupUrl = ""
      this.templateData.okGroupUrl = ""
      this.templateData.buttons = []
    },
    addEditTemplate() {
      this.isSaving = true
      this.axios.post("/sms/upsertVkTemplate", {
        templateId: this.editingTemplateId,
        templateData: {
          vk_template_name: this.templateData.title,
          service: this.templateData.vkService,
          notificationEmail: this.templateData.notifyEmail,
          vkGroupUrl: this.templateData.vkGroupUrl,
          okGroupUrl: this.templateData.okGroupUrl,
          template: this.templateData.text,
          vkTemplate: this.templateData.text,
          okTemplate: this.templateData.text,
          buttons: this.templateData.buttons
        }
      })
          .then(resp => {
            this.isSaving = false
            if (resp.data.error === "E_DUPLICATE_NAME")
              return this.$gNotify("Шаблон с таким именем уже существует", "error")

            this.$emit("templateSaved")
            this.$emit("close")
            this.clear()
          })
          .catch(resp => {
            this.isSaving = false
            this.$emit("templateSaved")
            this.$emit("close")
            this.clear()
          })
    },
    preloadEditingTemplate(_id, callback) {
      this.axios.get("/sms/getVkTemplateById", {params: {templateId: _id}})
          .then(resp => {
            this.templateData.title = resp.data.vk_name
            // this.templateData.oldName = resp.data.vk_name
            this.templateData.text = resp.data.template
            this.templateData.notifyEmail = resp.data.notificationEmail
            this.templateData.vkService = resp.data.service
            this.templateData.vkGroupUrl = resp.data.vkGroupUrl
            this.templateData.okGroupUrl = resp.data.okGroupUrl
            this.templateData.buttons = resp.data.buttons || []
            callback()
            // this.$refs.templateTextInput.setTextByTemplate({text: resp.data.text})
          })

    },

    addEmptyButton() {
      this.templateData.buttons.push({"label": "", "link": ""})
    },
    deleteButton(index) {
      this.templateData.buttons.splice(index, 1)
    }
  },
  data() {
    return {
      templateData: {
        title: "",
        text: "",
        oldName: "",
        notifyEmail: "",
        vkService: "",
        vkGroupUrl: "",
        okGroupUrl: "",
        buttons: []
      },
      isSaving: false,
      intVisible: false
    }
  }
}

</script>

<style>

</style>